import React from 'react';
import { FaTimes, FaTrophy, FaClock, FaGift } from 'react-icons/fa';

interface GuideModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
  icon: React.ComponentType<any>;
  fullContent?: string;
}

const GuideModal: React.FC<GuideModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  icon: Icon,
  fullContent,
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-dark-900/95 backdrop-blur-sm"
      onClick={onClose}
    >
      <div 
        className="glass rounded-2xl p-8 max-w-3xl w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-6">
          <div className="flex items-center space-x-4 flex-1">
            <div className="w-16 h-16 bg-gradient-to-br from-quantum-400 to-quantum-600 rounded-xl flex items-center justify-center flex-shrink-0">
              <Icon className="w-8 h-8 text-dark-900" />
            </div>
            <div className="flex-1">
              <h2 className="text-3xl font-bold text-white mb-2">{title}</h2>
              <p className="text-gray-400">{description}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors p-2 hover:bg-dark-700 rounded-lg flex-shrink-0"
            aria-label="Close modal"
          >
            <FaTimes className="w-6 h-6" />
          </button>
        </div>

        <div className="prose prose-invert max-w-none">
          {fullContent ? (
            <div className="text-gray-300 leading-relaxed space-y-4">
              {fullContent.split('\n\n').map((paragraph, i) => (
                <p key={i} className="text-lg">{paragraph}</p>
              ))}
            </div>
          ) : (
            <div className="text-gray-300 leading-relaxed space-y-4">
              <p className="text-lg">
                Understanding the fundamentals of online casino gaming is essential for making informed decisions 
                and maximizing your playing experience. This comprehensive guide covers everything you need to know 
                to navigate the world of UK online casinos with confidence.
              </p>
              <p className="text-lg">
                Whether you're a newcomer exploring your first welcome bonus or an experienced player looking to 
                optimize your strategy, our expert insights will help you make the most of your casino experience 
                while playing responsibly.
              </p>
              <p className="text-lg">
                Remember, the key to successful casino gaming lies in understanding the rules, managing your bankroll, 
                and always playing within your means. Take advantage of bonuses, but always read the terms and conditions 
                carefully before committing.
              </p>
            </div>
          )}
        </div>

        <div className="mt-8 pt-6 border-t border-dark-700">
          <button
            onClick={onClose}
            className="w-full bg-gradient-to-r from-quantum-500 to-quantum-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-quantum-600 hover:to-quantum-700 transition-all"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuideModal;

